
import {
  LOCATION_CHANGE, REGRESSION_PAGE,
  SET_CONCERNING_TRENDING_ONLY, SET_SELECTED_TESTS_ONLY, CHANGE_REGRESSION_FILTER
} from './../actions';

import {
  pageTypes as pageTypeHelpers,
  regressionPages
} from './../helpers/';

/**
 * This is used as a context reference for the Regression page currently in view.
 * As the user navigates from one page to the other the relevant helper data is swapped in.
 *
 * The values for each respective page are defined in 'helpers/regressionPage'
 * hence the documenation for the purpose of these properties can also be found there
 */
const initialState = {
  dispatcherJobName: '',
  dispatcherType: '',
  filters: {},
  scenariosBy: '',
  scenarioFeed: {},
  scenarioActions: [],
  scenariosByRadioButtons: [],
  pieStatsTitles: [],
  concerningTrendingOnly: false,
  currentDispatcherTestsOnly: true,
  pageType: {
    hasComments: false,
    needsJiraAuth: false,
    type: ''
  },
  productContext: { priorityOrder: [] }
};

const regressionPage = (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    if (!action.payload) {
      return state;
    }
    switch (action.payload.pathname) {
      case '/artifact-regression':
        return regressionPages.ARTIFACT_PAGE;
      case '/export-regression':
        return regressionPages.EXPORT_PAGE;
      case '/case-amending':
        return regressionPages.CASE_AMENDING;
      case '/case-merging':
        return regressionPages.CASE_MERGING;
      case '/diff':
        return regressionPages.DIFF_TOOL_PAGE;
      case '/acquisition':
        return regressionPages.ACQUISITION_PAGE;
      case '/white':
        return regressionPages.WHITE_PAGE;
      case '/installer':
        return regressionPages.INSTALLER_PAGE;
      case '/test-studio':
        return regressionPages.TEST_STUDIO_PAGE;
      case '/remote-acquire-regression':
        return regressionPages.REMOTE_AQUIRE_REGRESSION;
      case '/axiom-ui':
        return regressionPages.AXIOM_UI_PAGE;
      default:
        return state;
    }
  }

  if (action.type === REGRESSION_PAGE) {
    return {
      ...state,
      scenariosBy: action.scenariosBy
    };
  }

  if (action.type === SET_CONCERNING_TRENDING_ONLY) {
    return {
      ...state,
      concerningTrendingOnly: action.concerningTrendingOnly
    };
  }

  if (action.type === SET_SELECTED_TESTS_ONLY) {
    return {
      ...state,
      currentDispatcherTestsOnly: action.currentDispatcherTestsOnly
    };
  }

  if (action.type === CHANGE_REGRESSION_FILTER) {
    return {
      ...state,
      filters: { ...state.filters, [action.filter]: action.checked }
    };
  }

  return state;
};

export default regressionPage;

// * since the 'regressionPage' piece of the state is not data driven but is a dynamic store of
// * constants for the current view, an anti-pattern of consuming 'getRegressionPage'
// rather than its broken down counterparts in selectors should not have a performance cost.
// This enables us to pass fewer args into selectors.
// ! This should remain true for the intentions of this piece of the state but if it needs to change
// ! then performance impacts and a possible refactor needs to be considered
export const getRegressionPage = state => state.regressionPage;

export const getConcerningTrendingOnly =
  state => getRegressionPage(state).concerningTrendingOnly;
export const getCurrentDispatcherTestsOnly =
  state => getRegressionPage(state).currentDispatcherTestsOnly;
export const getDispatcherJobName = state => getRegressionPage(state).dispatcherJobName;
export const getDispatcherType = state => getRegressionPage(state).dispatcherType;
export const getPageType = state => getRegressionPage(state).pageType;
export const getScenariosBy = state => getRegressionPage(state).scenariosBy;
export const getScenarioFeed = state => getRegressionPage(state).scenarioFeed;
export const getScenarioActions = state => getRegressionPage(state).scenarioActions;
export const getScenariosByRadioButtons =
  state => getRegressionPage(state).scenariosByRadioButtons ?
    getRegressionPage(state).scenariosByRadioButtons : [];
export const getDisplayAllMetrics =
  state => getDispatcherType(state) !== pageTypeHelpers.ARTIFACTREGRESSION.type;
export const getPieStatsTitlesFunc = (state, scenariosByGroup) =>
  getRegressionPage(state).pieStatsTitlesFunc(scenariosByGroup);
export const getRegressionFilters = state => getRegressionPage(state).filters;


// WEBPACK FOOTER //
// src/reducers/regressionPage.js